// The drama and film funnels sell their own products: a Claude skill instead of
// the Claude Work Bundle, an income kit instead of Personal Boost and their own
// Complete Bundle, with the AI tools offer in between. The backend picks their
// chain by the funnel variant (shortdramas*, filmmaking* and their claude*
// twins); the client recognises a family by the upsell ids of the chain.
export type CreativeFamily = "drama" | "film";

export type CreativeUpsells = {
    skill: string;
    skillSale: string;
    incomeKit: string;
    bundle: string;
};

export const CREATIVE_UPSELLS: Record<CreativeFamily, CreativeUpsells> = {
    drama: {
        skill: "drama_writers_room",
        skillSale: "drama_writers_room_sale",
        incomeKit: "drama_income_kit",
        bundle: "drama_complete_bundle"
    },
    film: {
        skill: "film_studio",
        skillSale: "film_studio_sale",
        incomeKit: "film_income_kit",
        bundle: "film_complete_bundle"
    }
};

export const CREATIVE_FAMILIES = Object.keys(CREATIVE_UPSELLS) as CreativeFamily[];

// Public DO Spaces URLs for the skill archives and income kit PDFs.
export const CREATIVE_DOWNLOADS: Record<CreativeFamily, { skill: string; incomeKit: string }> = {
    drama: {
        skill: "https://tixu-upload.ams3.digitaloceanspaces.com/2cfebcaf-b96f-4bac-992c-42bbeb228960.zip",
        incomeKit: "https://tixu-upload.ams3.digitaloceanspaces.com/c2d07284-1f43-4393-baf4-2db5860e515d.pdf"
    },
    film: {
        skill: "https://tixu-upload.ams3.digitaloceanspaces.com/d904d37e-03b5-4749-8ffd-f745ae1fa95b.zip",
        incomeKit: "https://tixu-upload.ams3.digitaloceanspaces.com/5e4bf817-8b38-4ace-9ea2-8b17f4483014.pdf"
    }
};

export const getCreativeFamily = (upsellId: string | null): CreativeFamily | null =>
    CREATIVE_FAMILIES.find((family) => Object.values(CREATIVE_UPSELLS[family]).includes(upsellId ?? "")) ?? null;

export const getChainCreativeFamily = (upsells: { upsellId: string }[]): CreativeFamily | null =>
    upsells.map((upsell) => getCreativeFamily(upsell.upsellId)).find(Boolean) ?? null;
